import { LabCaseRunPrintOptionsModel } from '@app/api2/api';
import { Formik } from 'formik';
import * as React from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';
import { LabPrintingOptionsView } from '../../Labs/LabPrintingOptionsView';
import { BPButton } from '@/components/bp/bpbutton';

interface ICaseRunPrintDialogProps {
    open: boolean;
    onClose: () => void;
    onOpen: () => void;
    onOk: (values) => void;
    options: LabCaseRunPrintOptionsModel;
}

export const CaseRunPrintDialog: React.FunctionComponent<ICaseRunPrintDialogProps> = (props) => {
    // const [isOpen, setOpen] = React.useState(props.open)
    // const [initValues, setInitValues] = React.useState(props.options)
    const t = window.translation;

    return (
        <Formik
            initialValues={props.options}
            onSubmit={values => {
                props.onOk(values);
            }}>
            {fprops => {
                return <Modal as={Form} onSubmit={fprops.handleSubmit} open={props.open} onClose={() => { props.onClose(); }} onOpen={() => { props.onOpen(); }}>
                    <Modal.Header>{'Please select sections'}</Modal.Header>
                    <Modal.Content>
                        <LabPrintingOptionsView options={props.options} />
                    </Modal.Content>
                    <Modal.Actions>
                        <BPButton type="submit">
                            {window.translation.common.generate}
                        </BPButton>
                        <BPButton onClick={() => props.onClose()}>
                            {window.translation.common.cancel}
                        </BPButton>
                    </Modal.Actions>
                </Modal>
            }}
        </Formik>
    );
};
